import { render } from "./Invitation.vue?vue&type=template&id=5c9b7e88&scoped=true"
import script from "./Invitation.vue?vue&type=script&lang=js"
export * from "./Invitation.vue?vue&type=script&lang=js"

import "./Invitation.vue?vue&type=style&index=0&id=5c9b7e88&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c9b7e88"]])

export default __exports__